import * as React from 'react';
import { SCREEN_READER_MESSAGE_ID } from '../constants';
var style = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  width: '1px',
  margin: '-1px',
  padding: 0,
  overflow: 'hidden',
  position: 'absolute'
};
var renderDefaultMsg = function () {
  return React.createElement(React.Fragment, null, React.createElement("p", null, "Press the down arrow key to interact with the calendar and select a date. The following keyboard shortcuts can be used to change dates."), React.createElement("ul", null, React.createElement("li", null, "Enter Key: select the date in focus."), React.createElement("li", null, "Right and left arrow keys: Move backward (left) and forward (right) by one day."), React.createElement("li", null, "Up and down arrow keys: Move backward (up) and forward (down) by one week."), React.createElement("li", null, "Page up and page down keys: Switch months."), React.createElement("li", null, "Home and end keys: go to the first or last day of a week."), React.createElement("li", null, "Escape key: Return to the date input field.")));
};
var DatePickerDescription = function (_a) {
  var message = _a.message;
  return React.createElement("div", {
    id: SCREEN_READER_MESSAGE_ID,
    style: style
  }, message || renderDefaultMsg());
};
export default DatePickerDescription;